export default __webpack_public_path__ + "static/media/email.1ddb59e9.svg";